module.exports = __webpack_public_path__ + "img/pass.da3b3d45.svg";